import { Popover } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { IS_PRODUCTION } from 'constants/Global';
import { getLocale } from 'modules/i18n/selectors/data';
import { createNotification } from 'modules/toast-notifications/actions';
import { getCurrentUserJWTToken, getCustomName } from 'modules/users/selectors/currentUser';
import UserGuidesService from 'services/api/UserGuidesService';

import CampusContent from './CampusContent';
import * as styles from './Header.module.less';
import FleetbackCampus from '../../base/icons/fleetbackCampus-icon.svg';

const Campus = () => {
  const dispatch = useDispatch();
  const locale = useSelector(getLocale);
  const customName = useSelector(getCustomName);
  const userToken = useSelector(getCurrentUserJWTToken);

  const onFleetbackGuide = async (event) => {
    event.preventDefault();

    try {
      const websiteUrl = await UserGuidesService.getFleetbackUserGuideLink({ language: locale });
      // Set the cookie to autologin to campus
      if (IS_PRODUCTION) {
        document.cookie = `mo_jwt_token=${userToken}; Domain=.fleetback.com; path=/; Max-Age=15`;
      }
      window.open(websiteUrl.data, '_blank');
    } catch {
      dispatch(
        createNotification({
          type: 'error',
          message: {
            id: 'http.error.message',
            defaultMessage: 'Oops! Something went wrong.',
          },
        })
      );
    }
  };

  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      content={<CampusContent onFleetbackGuide={onFleetbackGuide} name={customName} />}
    >
      <div className={`${styles['header-usernav__wrapper']}`} data-cy="open-campus">
        <FleetbackCampus height="20" width="24" className={styles['header-usernav__icon']} />
        <span className={styles['header-usernav__label']}>
          <FormattedMessage id="about.campus" defaultMessage="Campus" />
        </span>
      </div>
    </Popover>
  );
};

export default Campus;
